const state = {};

const getters = {};

const actions = {
    async getItems({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/nlt/address-book`, { params: params })
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async getItem({ commit }, params) {
        return new Promise((resolve, reject) => {
            global.axios.get(`api/nlt/address-book/${params}`)
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async createItem({ commit }, data) {
        return new Promise((resolve, reject) => {
            global.axios.post(`api/nlt/address-book`, data)
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async updateItem({ commit }, data) {
        return new Promise((resolve, reject) => {
            global.axios.put(`api/nlt/address-book/${data.id}`, data)
                .then(response => {
                    resolve(response.data.data);
                })
                .catch(error => reject(error));
        });
    },
    async deleteItems({ commit }, ids) {
        return new Promise((resolve, reject) => {
            global.axios.delete(`api/nlt/address-book`, {
                data: {
                    ids: ids
                }
            })
            .then(response => {
                resolve(response);
            })
            .catch(error => reject(error));
        })
    },
};

const mutations = {};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}